const hasTempo = (range) => range && !(range[0] === 60 && range[1] === 200);

export const buildLoopQuery = (filters = {}, { limit = 75, skip = 0, shuffle = true, tempo } = {}) => {
  const params = new URLSearchParams();
  ['vibe_pack', 'search', 'mood_category', 'mood_tags', 'style_tags', 'vibe', 'key'].forEach((key) => {
    if (filters[key]) params.set(key, filters[key]);
  });
  if (filters.energy != null) { params.set('energy_min', filters.energy); params.set('energy_max', filters.energy); }
  if (filters.instrument_group) params.set('instrument_group', filters.instrument_group);
  const range = tempo ? [tempo, tempo] : filters.bpm_range;
  if (tempo || hasTempo(range)) { params.set('bpm_min', range[0]); params.set('bpm_max', range[1]); }
  params.set('shuffle', String(shuffle));
  params.set('limit', String(limit));
  params.set('skip', String(skip));
  return params;
};
